import { isMobileSafari, isSafari } from 'react-device-detect';

/**
 * True on Safari / WebKit — desktop Safari plus iOS/iPadOS Safari (which
 * `react-device-detect` splits into `isSafari` vs `isMobileSafari`).
 *
 * A call-time function (not the bare import-time constants) so callers can
 * read it inside a user gesture and mock it in tests without resetting
 * modules. Composes the existing detection rather than parsing the UA anew.
 */
export const isSafariBrowser = (): boolean => isSafari || isMobileSafari;
